import React, { useContext, useEffect, useMemo, useState } from 'react';
import { DataContext } from '../cnr/contexts/DataContext';
import DisplayProvider from '../cnr/contexts/DisplayContext';
import { FrameworkContext } from '../cnr/contexts/FrameworkContent';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { UiItemContext } from '../cnr/contexts/UiItemContext';
import SemElems from '../components/sem/SemElems';
import MotionWait from '../motions/MotionWait';
import { useRenders } from 'global/cnr/contexts/useHelpers/useRenders';

// SemUi has the Suspense
const NonAuthPage = React.lazy(() => import('../components/alerts/NonAuthPage'));
const SemUiActions = React.lazy(() => import('./SemUiActions'));

// PageAreaContent > PageContent > PageItem > UiItem > SemUi > SemElems > SemCardsWithProvider

/**
 * 
 * @param {object} props 
 * @returns a component
 * @calledFrom UiItem
 */
const SemUI = (props) => {

  const {
    selectedGroupItem,
    inSwiper,
    isMounted,
    _display_state
  } = props

  const [isSemUiLoaded, setIsSemUiLoaded] = useState(false);

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};
  const { paps_state, pageSettings } = states?.page_state ?? {};
  const { pathViews } = paps_state ?? {};
  const { onDemand } = pageSettings?.aps_global?.dataOptions ?? {};

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { desktopMode } = frameworkContext?.framework_state ?? {};

  // dataContext
  // REMOVE
  const dataContext = useContext(DataContext);
  const { data_state, data_handlers } = dataContext ?? {}
  const { confirmation, dataActionKey } = data_state ?? {}

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_state } = uiItemContext ?? {}
  const { viewItem, vld_item, props_viewItem } = item_state

  useRenders('SemUi', true, true, selectedGroupItem || viewItem)

  const { display, desktopDisplay } = viewItem ?? {}
  const _display = desktopMode && desktopDisplay ? desktopDisplay : display

  // ✅ Run effect unconditionally
  useEffect(() => {
    if (isSemUiLoaded) return;
    if (inSwiper && !isMounted) return;
    setIsSemUiLoaded(true);
  }, [isMounted, inSwiper, isSemUiLoaded]);

  let { sortProp, caption } = _display ?? {}

  if (!sortProp) { sortProp = 'name' }

  let { simpleData } = props

  const simpleContent = useMemo(() => (
    simpleData?.map((_, idx) => (
      <SemElems
        key={idx}
        selectedGroupItem={selectedGroupItem}
      />
    ))
  ), [pathViews, selectedGroupItem, simpleData])

  if (!isSemUiLoaded) {
    return null;
  }

  // console.log('props_viewItem', props_viewItem)
  // return <div>SEM UI</div>

  if (dataActionKey) {
    return <SemUiActions dataActionKey={dataActionKey} />
  } else {
    if (props_viewItem) {
      if (vld_item) {
        return <SemElems />
      } else if (simpleData) {
        return simpleContent
      } else {
        if (onDemand && data_handlers.handleSetFetchData) { data_handlers.handleSetFetchData(true) }
        if (confirmation && confirmation.success === false) {
          return <NonAuthPage itemType={'data'} />
        } else {
          return <MotionWait origin={'semUI'} />
        }
      }
    } else {
      return <MotionWait origin={'semUI'} />
    }
  }
}

export default SemUI